import axios, { AxiosResponse } from 'axios'
import { ApiResponse } from '../../../../shared/models/ApiModels'
import { IAuthActivityLogModel } from './AuthActivityLogModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const AUTH_ACTIVITY_LOGS_URL = `${API_URL}api/v1/auth-activity-logs`

export type AuthActivityLogResponse =
  | ApiResponse<IAuthActivityLogModel[]>
  | IAuthActivityLogModel[]

export async function loadAuthActivityLogs(): Promise<AxiosResponse<AuthActivityLogResponse>> {
  return axios.get<AuthActivityLogResponse>(AUTH_ACTIVITY_LOGS_URL)
}

export function extractAuthActivityLogs(data: AuthActivityLogResponse): IAuthActivityLogModel[] {
  if (Array.isArray(data)) return data
  if (data && Array.isArray((data as ApiResponse<IAuthActivityLogModel[]>).payload)) {
    return (data as ApiResponse<IAuthActivityLogModel[]>).payload
  }
  return []
}
